import { Injectable } from '@angular/core';
import { CreateResult } from '../models/create-result';
import { ServiceParameterModel } from '../models/service-parameter-model';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceParameterService {

  constructor(private _httpService: HttpService) { }

  public async GetServiceParameter(serviceId: number): Promise<ServiceParameterModel> {
    const httpResult = await this._httpService.apiGet<ServiceParameterModel>(`serviceParameter/GetServiceParameter/${serviceId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetServiceParameterById(parameterId: number): Promise<ServiceParameterModel> {
    const httpResult = await this._httpService.apiGet<ServiceParameterModel>(`serviceParameter/GetServiceParameterById/${parameterId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetAllServiceParameters(): Promise<ServiceParameterModel[]> {
    const httpResult = await this._httpService.apiGet<ServiceParameterModel[]>(`serviceParameter/GetAllServiceParameters`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async AddService(service: ServiceParameterModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`serviceParameter/AddServiceParameter`, service);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async EditService(service: ServiceParameterModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`serviceParameter/EditServiceParameter`, service);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async DeleteServiceParameter(entryId: number): Promise<CreateResult> {
    const httpResult = await this._httpService.apiDelete<CreateResult>(`serviceParameter/DeleteServiceParameter/${entryId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: httpResult.body.message, success: false };
  }
}
